import { Component, Input } from '@angular/core';
import { BaseComponent } from 'src/shared/components/base-component/base.component';
import { LocalSpinnerService } from './local-spinner.service';

@Component({
  selector: 'favie-local-spinner',
  templateUrl: './local-spinner.component.html',
  styleUrls: ['./local-spinner.component.scss'],
})
export class LocalSpinnerComponent extends BaseComponent {
  @Input() componentId: string;

  public showSpinner = false;

  constructor(private readonly localSpinnerService: LocalSpinnerService) {
    super();
  }

  onInit(): void {
    if (this.componentId) {
      this.localSpinnerService
        .registerComponent(this.componentId)
        .subscribe((loading: boolean) => {
          this.showSpinner = loading;
        });
    }
  }
}
